<template>
  <!--
    backend#57 / F-10: Ziel des Links aus der Bestaetigungsmail
    (LOGIN_URL/emailBestaetigen/<token>, 24 h, einmalig).

    Bestaetigt wird erst HIER per POST - nicht schon beim Abruf der Seite durch
    einen Link-Scanner im Postfach: Scanner laden die Seite, fuehren aber kein
    JavaScript aus.
  -->
  <v-app>
    <alertComponent />
    <v-container class="background fill-height flex" fluid>
      <div class="mx-auto align-center justify-center">
        <v-card elevation="4" max-width="435" min-width="300" class="pt-2">
          <v-card-title>
            <p class="headline mb-0">E-Mail-Adresse bestätigen</p>
          </v-card-title>
          <v-card-text data-cy="emailBestaetigenStatus">
            <div v-if="status === 'LAEUFT'" class="text-center my-6">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
            <div v-else-if="status === 'OK'">
              <p data-cy="emailBestaetigt">
                Vielen Dank – deine E-Mail-Adresse ist bestätigt und dein Konto
                freigeschaltet. Du kannst dich jetzt anmelden.
              </p>
            </div>
            <div v-else-if="status === 'LINK_ABGELAUFEN'">
              <p>
                Dieser Link ist abgelaufen. Fordere eine neue Bestätigungsmail an –
                der neue Link ist wieder 24 Stunden gültig.
              </p>
              <email-unbestaetigt text="Neue Bestätigungsmail anfordern:" />
            </div>
            <div v-else>
              <p data-cy="emailBestaetigenUngueltig">
                Dieser Link ist ungültig oder wurde bereits verwendet. Hast du deine
                Adresse schon bestätigt, melde dich einfach an.
              </p>
              <email-unbestaetigt text="Noch nicht bestätigt? Dann fordere eine neue Bestätigungsmail an:" />
            </div>
          </v-card-text>
          <v-card-actions v-if="status !== 'LAEUFT'">
            <v-btn block color="primary" @click="zurAnmeldung" data-cy="zurAnmeldung">
              Zur Anmeldung
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-container>
    <loginFooter />
  </v-app>
</template>

<script>
import loginFooter from "../components/loginFooter.vue";
import alertComponent from "../components/alertComponent.vue";
import EmailUnbestaetigt from "../components/auth/EmailUnbestaetigt.vue";

export default {
  name: "EmailBestaetigen",
  components: { loginFooter, alertComponent, EmailUnbestaetigt },
  props: { token: { type: String, default: "" } },
  data: () => ({ status: "LAEUFT" }),
  mounted() {
    return this.bestaetigen();
  },
  methods: {
    bestaetigen() {
      return this.$store.dispatch("emailBestaetigen", this.token).then((ergebnis) => {
        this.status = ergebnis;
      });
    },
    zurAnmeldung() {
      this.$router.push({ name: "Login", params: { mode: "login", redirect: "1" } });
    },
  },
};
</script>

<style scoped>
.background {
  background-color: #f3f3fa;
}
</style>
